var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9134 7.58286H1.66667C0.884595 7.58286 0.25 8.21746 0.25 8.99953C0.25 9.7816 0.884595 10.4162 1.66667 10.4162H16.9134L12.3319 14.9977C11.7774 15.5508 11.7796 16.4476 12.3315 17.0009C12.8843 17.5551 13.7813 17.5548 14.3349 17.0011L21.3347 10.0014C21.8889 9.44856 21.8886 8.55159 21.3349 7.99792L14.3352 0.998145C14.3351 0.998076 14.335 0.997988 14.3349 0.997919C13.7818 0.443616 12.8852 0.445845 12.3319 0.997693C11.7777 1.5505 11.7781 2.44747 12.3317 3.00114L16.9134 7.58286Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTwo);
export default __webpack_public_path__ + "static/media/arrow-right-two.575a73bcbddb75cf5887b4328c557beb.svg";
export { ForwardRef as ReactComponent };